

<div style="background-color: white;
padding: 1px 1px 1px 1px;">
<div class="content">

  <!--<section class="help">
      <h2>We're here<br>to help!</h2>
      <p>Ready to submit your items for grading and authentication?<br> See below for the steps of the process. We are excited to help you with your collection!</p>
      <a routerLink="/checkout" class="button">Get Started</a>
  </section>-->
  <!--<section class="how-it-works">
      <div class="how-it-works__right">
          <div class="how-it-works__step">
              <h3>01</h3>
          </div>
          <div class="how-it-works__text">
              <h3>Submitting your items</h3>
              <p>Submitting your items for grading and authentication to SGC is easy--just click the Start Your Submission button, add your cards, select shipping, process payment and mail your items to SGC. Semi-rigid holders (Card Saver I or Ultra Pro) are preferred. “Screwdown” holders will not be accepted. </p>
          </div>
      </div>
      <div class="how-it-works__left">
          <div class="how-it-works__step">
              <h3>02</h3>
          </div>
          <div class="how-it-works__text">
              <h3>The grading/authentication process</h3>
              <p>Our experts review your items with care and attention in accordance with SGC standards. We will keep you updated on the Submission Tracker every step of the way.</p>
          </div>
      </div>
      <div class="how-it-works__right">
          <div class="how-it-works__step">
              <h3>03</h3>
          </div>
          <div class="how-it-works__text">
              <h3>Once your items have been graded</h3>
              <p>After your items have been graded or authenticated, they are carefully packaged for shipping and sent off to your specified shipping address. We will send you a notification email with a tracking number upon shipment.</p>
          </div>
      </div>
      <div class="how-it-works__left">
          <div class="how-it-works__step">
              <h3>04</h3>
          </div>
          <div class="how-it-works__text">
              <h3>Additional tips</h3>
              <p>If you have any questions along the submission process, please contact Collector Support at <a href="mailto:support@gosgc.com" class="link">support@gosgc.com</a> or call toll-free at 800.742.9212.</p>
          </div>
      </div>
  </section>-->

  <section class="grading-scale">
      <h2>The SGC grading scale</h2>
      <!--<a routerLink="/checkout" class="button">Start Submission</a>-->
      <p>
          Today's sophisticated trading card market requires a specific grading scale. SGC uses a scale which eliminates the grades known as "tweeners": no grading scale is more accurate or consistent. Many industry experts agree that accurate grades mean more accurate prices for your trading cards!
      </p>
      <p>
          These grade descriptions are guidelines, designed to outline the evaluation process of the SGC grading team as they establish a specific physical condition grade. Other factors that may or may not contribute to the final assigned grade might not be specifically noted in these descriptions.
      </p>
      <div class="grading-scale__table">
          <ul class="grading-scale__values">
              <li *ngFor="let grade of grades" [class.grading-scale__values--selected]="isSelected(grade)" (click)="selectGrade(grade)">{{grade.value}}</li>
          </ul>
          <div class="grading-scale__description">
              <i>Grade</i>
              <p>{{selectedGrade.value}}</p>
              <i>Quality</i>
              <p>{{selectedGrade.quality}}</p>
              <i>Description</i>
              <p>{{selectedGrade.description}}</p>
          </div>
      </div>
  </section>

</div>
</div>
